import { Controller } from "@hotwired/stimulus"
import { EditorView, basicSetup } from "codemirror"
import { keymap } from "@codemirror/view"
import { indentWithTab } from "@codemirror/commands"
import { StreamLanguage } from "@codemirror/language"
import { shell } from "@codemirror/legacy-modes/mode/shell"

// Renders a CodeMirror editor for bash scripts, either editable (wrapping
// a hidden textarea, kept in sync on every edit so the surrounding <form>
// submits normally with no extra wiring) or read-only (syntax-highlighted
// display only, content passed via the `content` value).
export default class extends Controller {
  static targets = ["textarea", "editor"]
  static values = { readonly: Boolean, content: String }

  connect() {
    const doc = this.hasTextareaTarget ? this.textareaTarget.value : this.contentValue

    const extensions = [
      basicSetup,
      keymap.of([indentWithTab]),
      StreamLanguage.define(shell),
      EditorView.theme({
        "&": { fontSize: "13px", direction: "ltr" },
        ".cm-content": { fontFamily: "var(--font-mono, ui-monospace, monospace)", direction: "ltr" },
        ".cm-scroller": { minHeight: "220px" }, // ~10 lines at this font/line-height
      }),
    ]

    if (this.readonlyValue) {
      extensions.push(EditorView.editable.of(false))
    } else {
      extensions.push(
        EditorView.updateListener.of((update) => {
          if (update.docChanged) this.textareaTarget.value = update.state.doc.toString()
        }),
      )
    }

    this.view = new EditorView({ doc, extensions, parent: this.editorTarget })

    if (this.hasTextareaTarget) this.textareaTarget.style.display = "none"
  }

  disconnect() {
    this.view?.destroy()
  }
}
